module.exports = __webpack_public_path__ + "static/media/curriculum.41c352c2.png";